import { render, staticRenderFns } from "./MonitorsTrash.vue?vue&type=template&id=469399be&"
import script from "./MonitorsTrash.vue?vue&type=script&lang=js&"
export * from "./MonitorsTrash.vue?vue&type=script&lang=js&"
import style0 from "./MonitorsTrash.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports